import React from 'react';
import philosophy from '../../content/philosophy.json';
import Markdown from '../../content/Markdown';

const Philosophy = () => {
  return (
    <section name="philosophy" id="philosophy" className="scroll-to block spacer p-top-xl">
      <div className="wrapper">
        <div className="row gutter-width-sm">
          <div className="col-xl-8 col-lg-10 col-md-12 col-sm-12">
            <div className="title">
              <h2>{philosophy.title}</h2>
              <Markdown className="philosophy-text">{philosophy.text}</Markdown>
            </div>
          </div>
        </div>

        <div className="row gutter-width-sm">
          <div className="col-xl-6 col-lg-8 col-md-10 col-sm-12">
            <h3>{philosophy.partnersTitle}</h3>
            <Markdown>{philosophy.partnersIntro}</Markdown>
            {philosophy.partners.map((p, i) => (
              <React.Fragment key={i}>
                <h4>{p.title}</h4>
                <Markdown>{p.text}</Markdown>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
